<xemex-dialog-shell [title]="'installationGroups.addDevices.title' | translate">
  <div class="add-devices-dialog__body">
    <xemex-table
      [data]="tableData()"
      [columns]="columns"
      [loading]="isLoading()"
      [totalCount]="totalCount()"
      [selectable]="true"
      [selectionKey]="selectionKey"
      [selectedKeys]="selectedKeys()"
      [rowDisabled]="isMemberRow"
      [disabledRowsChecked]="true"
      (selectedKeysChange)="onSelectedKeysChange($event)"
      (pageChange)="onPageChange($event)"
    >
      <xemex-table-filter-bar
        [filterGroups]="filterGroups()"
        [searchPlaceholder]="'devices.filter.placeholderdeviceLDN' | translate"
        (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)"
      ></xemex-table-filter-bar>
    </xemex-table>
  </div>

  <div actions class="add-devices-dialog__actions">
    <span class="add-devices-dialog__count">
      {{ 'installationGroups.addDevices.selected' | translate: { count: selectedCount() } }}
    </span>
    <div class="add-devices-dialog__action-group">
      <xemex-text-button type="button" intent="primary" (click)="onCancel()">
        {{ 'general.btnCancel' | translate }}
      </xemex-text-button>
      <xemex-filled-button type="button" [disabled]="!selectedCount()" (click)="onAdd()">
        {{ 'installationGroups.addDevices.btnAdd' | translate: { count: selectedCount() } }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
